/** e.g. JUN 2026 - 001 */
export function formatServicebonRoundCode(signedAtOrFallback, roundNumber) {
  let d = signedAtOrFallback ? new Date(signedAtOrFallback) : new Date();
  if (Number.isNaN(d.getTime())) d = new Date();
  const month = d.toLocaleString('en-US', { month: 'short' }).toUpperCase();
  const year = d.getFullYear();
  const num = String(Math.max(1, Number(roundNumber) || 1)).padStart(3, '0');
  return `${month} ${year} - #${num}`;
}

export function getServicebonPlanningFallbackDate(order) {
  if (!order || typeof order !== 'object') return null;
  return order.scheduled_date || order.montagedatum || null;
}

export function formatServicebonRoundLabel(entry, roundNumber, order) {
  const dateRaw =
    (entry && typeof entry === 'object' ? entry.signed_at : null) ||
    getServicebonPlanningFallbackDate(order);
  return formatServicebonRoundCode(dateRaw, roundNumber);
}
